// components/UploadModal.jsx
import React from 'react';
import { X, Construction, Ship } from 'lucide-react';
import CustomDropdown from './CustomDropdown';
import BarLoader from './BarLoader'; // Assuming BarLoader is in the same 'components' directory

const UploadModal = ({
  showUploadModal,
  handleCloseUploadModal,
  selectedUploadProject,
  setSelectedUploadProject,
  selectedUploadShip,
  setSelectedUploadShip,
  uploadedFile,
  handleFileChange,
  handleUploadFile,
  isLoadingUpload,
  uploadLoaderMessage,
  uploadProgress,
  projects, // Pass projects from parent
  uploadModalShips, // Pass uploadModalShips from parent
  fetchUploadModalShips // Pass fetchUploadModalShips from parent
}) => {
  if (!showUploadModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden relative">
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center justify-between">
            Upload PERT Chart
            <button onClick={handleCloseUploadModal} className="text-gray-400 hover:text-gray-600">
              <X size={24} />
            </button>
          </h2>
          <form onSubmit={handleUploadFile} className="space-y-6">
            <div>
              <label htmlFor="uploadProject" className="block text-sm font-medium text-gray-700 mb-2">Project</label>
              <CustomDropdown
                value={selectedUploadProject}
                onChange={(value) => {
                  setSelectedUploadProject(value);
                  setSelectedUploadShip('');
                  fetchUploadModalShips(value);
                }}
                options={projects}
                placeholder="Select Project"
                icon={Construction}
              />
            </div>
            <div>
              <label htmlFor="uploadShip" className="block text-sm font-medium text-gray-700 mb-2">Ship</label>
              <CustomDropdown
                value={selectedUploadShip}
                onChange={setSelectedUploadShip}
                options={uploadModalShips}
                placeholder="Select Ship"
                icon={Ship}
                disabled={!selectedUploadProject || uploadModalShips.length === 0}
              />
            </div>
            <div>
              <label htmlFor="file-upload" className="block text-sm font-medium text-gray-700 mb-2">Select File</label>
              <input
                id="file-upload"
                type="file"
                accept=".pdf,.xlsx,.xls,.png,.jpg,.jpeg"
                onChange={handleFileChange}
                className="w-full text-sm text-gray-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-xl file:border-0
                            file:text-sm file:font-semibold
                            file:bg-blue-50 file:text-blue-700
                            hover:file:bg-blue-100"
              />
              {uploadedFile && (
                <p className="mt-2 text-sm text-gray-500">Selected file: {uploadedFile.name}</p>
              )}
            </div>
            <button
              type="submit"
              className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-semibold rounded-xl shadow-md hover:from-blue-700 hover:to-indigo-800 transition-all duration-200"
              disabled={isLoadingUpload}
            >
              {isLoadingUpload ? 'Uploading...' : 'Upload'}
            </button>
          </form>
        </div>
        {isLoadingUpload && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-10">
                <BarLoader message={uploadLoaderMessage} type="upload" currentProgress={uploadProgress} />
            </div>
        )}
      </div>
    </div>
  );
};

export default UploadModal;